import { MapPin, Phone, Mail } from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();

  const socialLinks = [
    { name: "Instagram", url: "#" },
    { name: "Facebook", url: "#" },
    {
      name: "WhatsApp",
      url: "https://wa.me/919256930540?text=Hello%20Jungle%20Villa%2C%20I%20want%20to%20book",
    },
  ];

  return (
    <footer className="bg-[#0f172a] text-white">

      {/* MAIN */}
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-10">

        {/* LEFT - INFO */}
        <div className="space-y-4">
          <h3 className="text-xl font-semibold">
            Jungle Villa & Restaurant
          </h3>

          <a
            href="https://www.google.com/maps?q=Mount+Abu,Rajasthan"
            target="_blank"
            rel="noopener noreferrer"
            className="flex gap-2 text-gray-300 hover:text-white"
          >
            <MapPin size={18} />
            Main Road, Hetamji, Mount Abu, Rajasthan, 307501
          </a>

          <a
            href="tel:+919256930540"
            className="flex gap-2 text-gray-300 hover:text-white"
          >
            <Phone size={18} />
            +91 9256930540
          </a>

          <p className="flex gap-2 text-gray-300">
            <Mail size={18} />
            vikramsinghabu67@gmail.com
          </p>
        </div>

        {/* CENTER - BRANDING */}
        <div className="text-center flex flex-col justify-center">

          <p className="text-gray-400 text-sm">
            © {year} Jungle Villa & Restaurant
          </p>

          <p className="mt-2 text-gray-300">
            Crafted with ❤️ Gauransh Jaroli
          </p>

          <a
            href="https://parshwebcraft.in"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:underline mt-1"
          >
            Product by ParshWebCraft
          </a>

        </div>

        {/* RIGHT - SOCIAL + MAP */}
        <div className="flex flex-col items-start md:items-end gap-4">

          {/* Social */}
          <div className="flex gap-4">
            {socialLinks.map((item) => (
              <a
                key={item.name}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white text-sm"
              >
                {item.name}
              </a>
            ))}
          </div>

          {/* MAP */}
          <div className="w-full md:w-64 h-32 rounded-lg overflow-hidden border">
            <iframe
              title="Mount Abu Location"
              src="https://www.google.com/maps?q=Mount%20Abu&output=embed"
              className="w-full h-full"
              loading="lazy"
            />
          </div>

        </div>
      </div>

      {/* BOTTOM */}
      <div className="border-t border-gray-700 text-center text-gray-400 text-xs py-3">
        Premium Nature Retreat • Mount Abu
      </div>

    </footer>
  );
};

export default Footer;